import React, { useEffect } from "react";
import Header from '../Component/Header'
import Slider from '../Component/Slider'
import { Link } from 'react-router-dom'
import News from'../Component/News'
import Campuscare from'../Component/Campuscare'
import Events from'../Component/Events'
import TopperXII from'../Component/TopperXII'
import TopperX from'../Component/TopperX'
import Notification from'../Component/Notification'
import OnlineReg from'../Component/OnlineReg'
import Birthday from'../Component/Birthday'
import Gallery from'../Component/Gallery'
import Message from'../Component/Message'
import Footer from'../Component/Footer'
import LazyLoad from 'react-lazyload';
const Home = () => {
   useEffect(() => {
      // Set the page title
      document.title = 'Home - Presentation Convent School Delhi';  
    }, []);
  return (
     <>
      <Notification/>
       <Campuscare/>
       <OnlineReg/>
        <Header/>
        <div className="mainhomeslider">
            
            <Slider/>
            <div className="midsection">
            <div className="midsectiondiv fst">
               <div className="midsectionbox">
                    <div className="midsectionboximg">
                       <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/motto.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                    </div>
                    <div className="midsectionboxdesc">
                         <div className="midsectionboxtitle">
                              <h6>MOTTO</h6>
                         </div>
                         <div className="midsectionboxpara">
                            <p><b>The motto of the school is “VIRTUE” and “LABOUR”. </b> The students are expected to strive for these and to practice justice, charity, honesty, truthfulness, generosity, loyalty and gratitude. They must work hard in school and at home and realise the dignity of labour.  </p>
                         </div>
                    </div>
               </div>
            </div>
           
            <div className="midsectiondiv scd">
               <div className="midsectionbox">
               <div className="midsectionboximg">
                  <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/objective.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                </div>
                    <div className="midsectionboxdesc"> 
                    
                         <div className="midsectionboxpara">
                            <ul>
                            <li> To Provide qualitative teaching-learning process.  </li>
                            <li> To create a just society. </li>
                            <li> To promote human values and character formation. </li>
                            <li> To work towards empowerment of girls. </li>
                            <li> To work towards environmental protection and conservation. </li>
                            </ul>
                         </div>
                         <div className="midsectionboxtitle">
                         <h6> OBJECTIVES</h6>
                     </div>
                    </div> 
               </div>
            </div>
        </div>
            </div>  
         
         <div className="homeabout">
            <div className="container-fluid fulwidth">
             <div className="row">
                 <div className="col-lg-6">
                   <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/about.png" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                 </div>
                 <div className="col-lg-6">
                     <div className="titleheading">
                          <h1><span>presentation convent sr. sec. school</span> ABOUT US</h1>
                     </div>
                      <div className="homeaboutdesc">
                          <p> is a Christian minority unaided English medium school exclusively for girls. It is administered by the Sisters of the Presentation of the Blessed Virgin Mary, under the aegis of the Society of the Presentation Delhi. The Society is registered under the Societies Registration Act, XXI of 1860 (Punjab Amendment) Act 1957, as extended to the Union Territory of Delhi. The school is situated in the heart of Delhi, offering a nurturing and value-based educational environment.</p>
                         <p> It is Affiliated to the Central Board of Secondary Education, Delhi Region at Senior Secondary level. The Affiliation number is 2730061. It had been granted provisional affiliation in 1977. The Provisional Affiliation has now been further extended up to 31.03.2028.</p>
                      </div>
                      <div className="mainbtn">
                          <Link to="/SchoolInformation"> <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/knowmorebtn.png" className="img-fluid" alt="Pcs Delhi"/></LazyLoad></Link>
                      </div>
                      <div className="schoolsong">
                          <h6>our school song</h6> 
                          <audio controls><source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/audio.mp3" type="audio/mpeg"/></audio>
                      </div>
                 </div>
              </div>
            </div>
         </div>
         <div className="homenews">
         <div className="container-fluid fulwidth">
             <div className="row g-5">
             <div className="col-xl-4 col-lg-6">
               <div className="maintitle">
                     <div>
                        <p>Notices &</p>
                        <h1>NEWS   <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/line.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                        </h1>
                     </div>
                     <Link to="/News"><i className="bi bi-chevron-double-right"></i></Link>
                     <div className="clr">
                       </div>
               </div>
               <News/>
               </div>
               <div className="col-xl-8 col-lg-6 eventpd">
                 <div className="maintitle eventgif">
                       <div>
                       <p>Events &  </p>
                       <h1>  ACTIVITES <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/event.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad></h1>
                       </div>
                       <Link to="/events"><i className="bi bi-chevron-double-right"></i></Link>
                       <div className="clr">
                       </div>
                 </div>
                   <Events/>
               </div>
             </div>
         </div>
       </div>
       <div className="homemsgsec">
       <div className="container-fluid fulwidth">
           <div className="row">
                <div className="col-lg-12">
                <div className="maintitle eventgif">
                    <div>
                       <p>principal </p>
                       <h1>   MESSAGE<LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/msg.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad></h1>
                       </div>
                       
                       </div>

               <Message/>
               <div className="mainbtn">
                 <Link to="/PrincipalMessage"><LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/knowmorebtn.png" className="img-fluid" alt="Pcs Delhi"/></LazyLoad></Link>
           </div>
                    </div>
            </div>
    </div>
</div>
       <div className="topperandbirth">
           <div className="container-fluid fulwidth">
               <div className="row g-5">
                    <div className="col-lg-4">
                    <div className="maintitle eventgif">
                    <div>
                           <p>birthday </p>
                           <h1>  SECTION<LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/birth.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                           </h1>
                           </div>
                           
                           </div>
                     
                         <div className="birthdaysec">
                           <div className="topperribbon"> 
                             <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/birthdayribbon.png" className="img-fluid"/>   </LazyLoad>
                           </div>  
                                <Birthday/>
                           <div className="topperribbonbottom"> 
                              <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/birthdayribbonbottom.png" className="img-fluid"/>   </LazyLoad>
                           </div>
                         </div>
                    </div>
                    <div className="col-lg-8"> 
                          <div className="toppersecbg">
                          <div className="maintitle eventgif">
                     <div>
                           <p>Toppers </p>
                           <h1>  SECTION<LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/toopers.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad>
                           </h1>
                           </div>
                           
                           </div>
                          <div className="topperribbon"> 
                          <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/classicn.png" className="img-fluid"/>   </LazyLoad>
                      </div>           
                              <div className="row">
                              <div className="col-lg-11">
                                 <TopperXII/>
                              </div>
                              <div className="col-lg-1 topperbtn maintitle">
                                 <Link to="/TopperXII"> <i className="bi bi-chevron-double-right"></i> </Link>
                              </div>
                              </div>
                              
                              <div className="topperribbon">
                                       <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/classicn10.png" className="img-fluid"/></LazyLoad>
                              </div>
                                       
                              <div className="row">
                              <div className="col-lg-11">
                                 <TopperX/>
                              </div>
                              <div className="col-lg-1 topperbtn maintitle">
                                 <Link to="/TopperX"> <i className="bi bi-chevron-double-right"></i> </Link>
                              </div>
                              </div>
                          </div>
                     </div>
                </div>
             </div>
        </div>  
        <div className="homegallery">
        <div className="container-fluid fulwidth">
           <div className="row">
                <div className="col-lg-12">
                <div className="maintitle eventgif">
                <div>
                      <p> ACTIVITES </p>
                      <h1>   & CELEBRATION<LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/PCSD/public/Images/gal.gif" className="img-fluid" alt="Pcs Delhi"/></LazyLoad></h1>
                      </div>
                      <Link to="/PhotoGallery"><i className="bi bi-chevron-double-right"></i></Link>
                       <div className="clr">
                       </div>
                      </div>
                     <Gallery/>
                     
                </div>
           </div>
         </div>
      </div>
      <Footer/>
     </>
  );
};

export default Home
